// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extra-value {
  border-radius: 200px;
  padding: 6px 8px 6px 12px;
  background-color: var(--grey);
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: max-content;
}

.extra-clear {
  outline: none;
  border: none;
  background-color: var(--dark-grey);
  color: var(--white);
  display: inline-flex;
  align-items: center;
  border-radius: 200px;
  cursor: pointer;
  padding: 4px;
}

[data-theme=dark] .extra-value {
  background-color: rgba(1, 1, 1, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/extra.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAGE;EACE,oCAAA;AAAJ","sourcesContent":[".extra-value {\n  border-radius: 200px;\n  padding: 6px 8px 6px 12px;\n  background-color: var(--grey);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: max-content;\n}\n\n.extra-clear {\n  outline: none;\n  border: none;\n  background-color: var(--dark-grey);\n  color: var(--white);\n  display: inline-flex;\n  align-items: center;\n  border-radius: 200px;\n  cursor: pointer;\n  padding: 4px;\n}\n\n[data-theme='dark'] {\n  .extra-value {\n    background-color: rgba(1, 1, 1, 0.2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
